module.exports = __webpack_public_path__ + "static/poster-home-page-16face2490864600d2af7284d5793284.jpeg";